import { PAGE_TYPE_CART } from 'shared/consts'
import {
  FLYOUT_BANNER_CLICK,
  FLYOUT_BANNER_CLOSE_BUTTON_CLICK,
  OWN_BRAND_PRODUCT_ADDTOCART,
} from 'shared/experiments/browser/advertisingFlyoutBanner/const'
import {
  AD_FLYOUT_BANNER,
  EXPERIMENT_VARIATION,
} from 'shared/experiments/consts'
import {
  activateExperiment,
  getExperimentOnClient,
} from 'shared/experiments/utils/experiments'
import trackOptimizelyEvent from 'shared/experiments/utils/trackOptimizelyEvent'
import store from 'shared/store'

const BANNER_TIMEOUT = 15000

export default () => {
  const { isEnabled, variant } = getExperimentOnClient(AD_FLYOUT_BANNER)
  const publicRuntimeConfig = store.getState()?.publicRuntimeConfig
  const { pageType } = publicRuntimeConfig?.pageProperties || {}

  if (
    !isEnabled ||
    variant === EXPERIMENT_VARIATION.DEFAULT ||
    pageType === PAGE_TYPE_CART
  ) {
    return
  }

  const bannerButton = <HTMLElement>(
    document.querySelector('[name="ad-flyout-banner-button"]')
  )
  const banner = <HTMLElement>(
    document.querySelector('.o-AdvertisingFlyoutBanner__bannerContainer')
  )

  if (isEnabled && bannerButton && banner) {
    if (sessionStorage.getItem(AD_FLYOUT_BANNER) !== 'true') {
      setTimeout(() => {
        bannerButton.classList.remove('u-hidden')

        setTimeout(() => {
          // Remove hidden class from the banner element after another 15 seconds, only if it hasn't been closed before
          if (!bannerButton.classList.contains('u-hidden')) {
            sessionStorage.setItem(AD_FLYOUT_BANNER, 'true')
            banner.classList.remove('u-hidden')
            bannerButton.classList.add('u-hidden')
          }

          setTimeout(() => {
            // Hide the banner element after another 15 seconds, only if it was visible before
            if (!banner.classList.contains('u-hidden')) {
              banner.classList.add('u-hidden')
              bannerButton.classList.remove('u-hidden')
            }
          }, BANNER_TIMEOUT)
        }, BANNER_TIMEOUT)
        void activateExperiment(AD_FLYOUT_BANNER)
      }, BANNER_TIMEOUT)
    }

    bannerButton.addEventListener('click', () => {
      banner.classList.remove('u-hidden')
      bannerButton.classList.add('u-hidden')
    })
    banner.addEventListener('click', event => {
      const element = <HTMLElement>event.target

      if (element.closest('.o-AdvertisingFlyoutBanner__closeIcon')) {
        banner.classList.add('u-hidden')
        bannerButton.classList.add('u-hidden')

        trackOptimizelyEvent(FLYOUT_BANNER_CLOSE_BUTTON_CLICK)
      } else if (element.closest('.o-AdvertisingFlyoutBanner__bannerImage')) {
        trackOptimizelyEvent(FLYOUT_BANNER_CLICK)
      }
    })

    // Close banner when clicking outside of it
    document.addEventListener('click', event => {
      const target = <HTMLElement>event.target

      if (
        !bannerButton.contains(target) &&
        !banner.contains(target) &&
        !banner.classList.contains('u-hidden')
      ) {
        banner.classList.add('u-hidden')
        bannerButton.classList.add('u-hidden')
      }
    })

    if (
      window.location.pathname + window.location.search ===
      '/search.htm?b=1&q=redcare'
    ) {
      const ownBrandsAddToCartButton = <HTMLElement>(
        document.querySelector('.o-SearchProductListItem__ProductAction')
      )

      ownBrandsAddToCartButton.addEventListener('click', () => {
        trackOptimizelyEvent(OWN_BRAND_PRODUCT_ADDTOCART)
      })
    }
  }
}
